module.exports = __webpack_public_path__ + "img/intro_sidebar.02dfd9d8.jpg";